import { Injectable, inject } from '@angular/core';
import {DatabaseService} from '../shared/database.service';
import {BehaviorSubject, Observable} from 'rxjs';
import {ConfigAPI} from './configuration.model';
import {MasterDataService} from '../master-data/master-data-service';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {
  private databaseService = inject(DatabaseService);
  private masterDataService = inject(MasterDataService);


  configBS$: BehaviorSubject<ConfigAPI | null> = new BehaviorSubject(null);
  config$: Observable<ConfigAPI | null> = this.configBS$.asObservable();

  constructor() {
    this.loadConfig();
  }

  loadConfig() {
    this.databaseService.loadConfig()
      .subscribe(
        {
          next: (config) => {
            this.configBS$.next(config);
          },
          error: (error) => {
            console.log('Http error');
          }
        }
      );
  }

  saveConfiguration(map: Map<string, string>, configUuid: string) {
    this.databaseService.saveConfig(map, configUuid)
      .subscribe({
        next: (response) => {
          this.masterDataService.handleResponse(response);
        },
        error: (err) => this.masterDataService.savingErrorMessage()
      });
  }

}
